//import * as api from "../../api"; 


export const initUser = (userData) => async (dispatch)=>{
  try {
      
  } catch (error) {
      console.log(error);
  }
}

